import tables from './Table';
import text from './Text';
import lists from './Lists';

export default {
    ...tables,
    ...lists,
    ...text
};
